export type UnitPayback = {
  progressPercentage: number
  displayPercentage: number
  profitPence: number | null
}

// Match Arctic Line's payoff rules, keeping calculations in pence.
export function calculateUnitPayback(purchasePricePence: number | null, revenuePence: number): UnitPayback | null {
  if (purchasePricePence == null || !Number.isFinite(purchasePricePence) || purchasePricePence <= 0
    || !Number.isFinite(revenuePence) || revenuePence < 0) return null
  const rawPercentage = revenuePence / purchasePricePence * 100
  const isPaidOff = revenuePence >= purchasePricePence
  return {
    progressPercentage: Math.min(rawPercentage, 100),
    displayPercentage: isPaidOff ? 100 : Math.min(Math.floor(rawPercentage), 99),
    profitPence: isPaidOff ? revenuePence - purchasePricePence : null,
  }
}

export function calculateInventorySummary(units: ReadonlyArray<{ purchase_price_pence: number | null; revenue_pence: number }>) {
  let paidOffUnits = 0, costedUnits = 0, purchasePence = 0, recoveredPence = 0, profitPence = 0
  for (const unit of units) {
    const cost = unit.purchase_price_pence, revenue = Number(unit.revenue_pence)
    const payback = calculateUnitPayback(cost, revenue)
    if (!payback || cost == null) continue
    costedUnits++
    if (payback.profitPence != null) paidOffUnits++
    purchasePence += cost
    // A profitable unit cannot pay off another unit's outstanding purchase cost.
    recoveredPence += Math.min(revenue, cost)
    profitPence += revenue - cost
  }
  return {
    totalUnits: units.length,
    paidOffUnits,
    costedUnits,
    payback: calculateUnitPayback(purchasePence, recoveredPence),
    profitPence: costedUnits ? profitPence : units.length ? null : 0,
  }
}

const wholePounds = new Intl.NumberFormat('en-GB', { maximumFractionDigits: 0 })
export function formatUnitProfit(profitPence: number) {
  return `+ £${wholePounds.format(Math.floor(profitPence / 100))}`
}
